/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}.table-responsive-vertical[_ngcontent-%COMP%]{margin-top:20px;width:100%}.table-responsive-vertical[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{width:100%}.scroll[_ngcontent-%COMP%]{overflow-y:auto}.margin-top[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%]{margin-top:15px}.margin-bottom[_ngcontent-%COMP%]{margin-bottom:15px}.mat-form-field[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/usersearch/usersearch.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js